if (!customElements.get('product-page-bundle-presets')) {
  class ProductPageBundlePresets extends HTMLElement {
    constructor() {
      super();

      this.querySelectorAll('a[href*=addbundle]')
        .forEach(link => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const href = target.getAttribute('href');
            const urlParams = new URLSearchParams(href);

            if (!urlParams.get('addbundle')) return;
  
            let productHandles = urlParams.get('addbundle').split(',');
  
            document.dispatchEvent(
              new CustomEvent('selectBundleProducts.ppbundle', {
                detail: { productHandles }
              })
            );

            const productPageBundle = document.querySelector('product-page-bundle');

            if (productPageBundle) {
              window.scrollTo({
                top: productPageBundle.getBoundingClientRect().top + window.scrollY - 150, 
                behavior: 'smooth'
              });
            }
            
          });
        });
    }
  }
  
  customElements.define('product-page-bundle-presets', ProductPageBundlePresets);
}